import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ServiceSingleSidebar from './service-single-components/sidebar';
import Solutions from './service-single-components/solution';
import Benefits from './service-single-components/benefits';
import servicesData from './services.json'; // adjust path if needed

const ServiceSingleSection = () => {
    const { slug } = useParams();
    const [service, setService] = useState(null);

    useEffect(() => {
        const foundService = servicesData.find(s => s.slug === slug);
        setService(foundService);
    }, [slug]);

    if (!service) {
        return <div className="container"><p>Loading service details...</p></div>;
    }

    return (
        <section className="wpo-service-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-12">
                        <div className="wpo-service-single-wrap">
                            <div className="wpo-service-single-content">
                                <img src={service.image} alt={service.title} />
                                <div className="wpo-service-single-content-des">
                                    <h2>{service.title}</h2>
                                    <p>{service.description}</p>
                                    {service.content && service.content.map((paragraph, index) => (
                                        <p key={index}>{paragraph}</p>
                                    ))}
                                    {service.subImages && (
                                        <div className="wpo-service-single-sub-img">
                                            <ul>
                                                {service.subImages.map((img, idx) => (
                                                    <li key={idx}><img src={img} alt="" /></li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                            {/* {/* <Solutions /> */}
                            <Benefits />
                        </div>
                    </div>
                    <ServiceSingleSidebar />
                </div>
            </div>
        </section>
    );
};

export default ServiceSingleSection;
